<template>
    <div>
        <navView :isSelect="isSelect" @handleCommand="handleCommand" />
        <div class="about">
            <h2 class="title">{{ $t('dr.Founder') }}</h2>
            <div class="about-person">
                <div class="about-box">
                    <img src="../assets/images/about/sl.png" alt="">
                    <div class="about-title">{{ $t('dr.name02') }}</div>
                    <div class="about-sub-title">{{ $t('dr.introduce02') }}</div>
                </div>
                <div class="about-box">
                    <img src="../assets/images/about/xw.png" alt="">
                    <div class="about-title">{{ $t('dr.name03') }}</div>
                    <div class="about-sub-title">{{ $t('dr.introduce03') }}</div>
                </div>
                <div class="about-box">
                    <img src="../assets/images/about/about05.png" alt="">
                    <div class="about-title">{{ $t('dr.name01') }}</div>
                    <div class="about-sub-title">{{ $t('dr.introduce01') }}</div>
                    <div class="about-sub-title" style="font-weight: 600;">{{ $t('dr.Interests') }}</div>
                    <div class="about-sub-title">{{ $t('dr.conetent01') }}<br />
                        {{ $t('dr.conetent02') }}<br />
                        {{ $t('dr.conetent03') }}</div>
                </div>
                <div class="about-box">
                    <img src="../assets/images/about/lxy.jpg" alt="">
                    <div class="about-title">{{ $t('dr.name04') }}</div>
                    <div class="about-sub-title">{{ $t('dr.introduce04') }}</div>
                </div>
                <div class="about-box">
                    <img src="../assets/images/about/cjl.png" alt="">
                    <div class="about-title">{{ $t('dr.name05') }}</div>
                    <div class="about-sub-title">{{ $t('dr.introduce05') }}</div>
                </div>
            </div>
            <h2 class="title">{{ $t('dr.Partner') }}</h2>
            <div class="swiper">
                <el-carousel height="150px" v-if="isPhone">
                    <el-carousel-item>
                        <img class="img" src="../assets/images/about/cityulogo.png" alt="">
                    </el-carousel-item>
                    <el-carousel-item>
                        <img class="img" src="../assets/images/about/bcmlogo.png" alt="">
                    </el-carousel-item>
                    <el-carousel-item>
                        <img class="img" src="../assets/images/about/cuhkszlogo.png" alt="">
                    </el-carousel-item>
                    <el-carousel-item>
                        <img class="img" src="../assets/images/about/about03.png" alt="">
                    </el-carousel-item>
                    <el-carousel-item>
                        <img class="img" src="../assets/images/about/about04.png" alt="">
                    </el-carousel-item>
                </el-carousel>
                <el-carousel :interval="4000" type="card" height="400px" v-if="!isPhone">
                    <el-carousel-item>
                        <img class="img" src="../assets/images/about/cityulogo.png" alt="">
                    </el-carousel-item>
                    <el-carousel-item>
                        <img class="img" src="../assets/images/about/bcmlogo.png" alt="">
                    </el-carousel-item>
                    <el-carousel-item>
                        <img class="img" src="../assets/images/about/cuhkszlogo.png" alt="">
                    </el-carousel-item>
                    <el-carousel-item>
                        <img class="img" src="../assets/images/about/about03.png" alt="">
                    </el-carousel-item>
                    <el-carousel-item>
                        <img class="img" src="../assets/images/about/about04.png" alt="">
                    </el-carousel-item>
                </el-carousel>
            </div>
        </div>

        <footerView />
    </div>
</template>

<script>
import navView from '../components/nav.vue';
import footerView from '../components/footer.vue';
export default {
    components: {
        navView, footerView,
    },
    data() {
        return {
            isSelect: 0,
            isPhone: false
        }
    },
    created() {
        this.isSelect = this.$route.query.index
    },
    mounted() {
        var info = navigator.userAgent;
        //通过正则表达式的test方法判断是否包含“Mobile”字符串
        this.isPhone = /mobile/i.test(info);
        //如果包含“Mobile”（是手机设备）则返回true
        console.log('isPhone', this.isPhone)
    },
    methods: {
        handleCommand(name) {
            if (name == 'en') {
                this.$i18n.locale = 'en'
            } else {
                this.$i18n.locale = 'zh'
            }
        }
    }
}
</script>

<style scoped lang="scss">
@media only screen and (max-width: 750px) {
    .el-carousel__item h3 {
        color: #475669;
        font-size: 14px;
        opacity: 0.75;
        line-height: 200px;
        margin: 0;
    }

    .el-carousel__item:nth-child(2n) {
        background-color: #fff;
    }

    .el-carousel__item:nth-child(2n+1) {
        background-color: #fff;
    }

    .img {
        display: block;
        margin: 0 auto;
        height: 100%;
        object-fit: cover;
    }

    .title {
        color: #1b5fc1;
        margin-top: 40px;
        font-size: 18px;
    }

    .swiper {
        padding-bottom: 20px;
    }

    .about {
        padding: 60px 20px 0 20px;

        .about-person {
            width: 100%;
        }

        .about-box {
            img {
                width: 100%;
                height: 400px;
                object-fit: cover;
                margin-top: 20px;
            }

            .about-title {
                text-align: center;
                font-weight: bold;
                font-size: 20px;
                color: #333;
                line-height: 40px;

            }

            .about-sub-title {
                text-align: center;
                font-size: 16px;
                line-height: 26px;
            }
        }
    }
}

@media only screen and (min-width: 751px) {

    .el-carousel__item h3 {
        color: #475669;
        font-size: 14px;
        opacity: 0.75;
        line-height: 200px;
        margin: 0;
    }

    .el-carousel__item:nth-child(2n) {
        background-color: #fff;
    }

    .el-carousel__item:nth-child(2n+1) {
        background-color: #fff;
    }

    .img {
        display: block;
        margin: 0 auto;
        height: 100%;
        object-fit: cover;
    }

    .title {
        color: #1b5fc1;
        margin-top: 80px;
    }

    .swiper {
        padding: 30px 0;
    }

    .about {
        padding: 160px 60px 0 60px;

        .about-person {
            width: 100%;
            display: flex;
            justify-content: space-between;
        }

        .about-box {
            width: 19%;

            img {
                width: 100%;
                height: 400px;
                object-fit: cover;

            }

            .about-title {
                text-align: center;
                font-weight: bold;
                font-size: 20px;
                color: #333;
                line-height: 40px;

            }

            .about-sub-title {
                text-align: center;
                font-size: 16px;
                line-height: 26px;
            }
        }
    }
}
</style>